module.exports = __webpack_public_path__ + "static/media/Storage-how-it-works-4.e5a809a4.jpg";